import { Observable } from 'rxjs/Observable';
import { AuthService } from './auth.service';
import { SecurityService } from './../security/security.service';
import { UserModel } from './../shared/models/user-info.model';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { StartupService } from 'app/shared/services/startup.service';

@Injectable()
export class UserResolver implements Resolve<UserModel> {

  constructor(private securityService:SecurityService,
     private authService:AuthService) {}

  resolve(route: ActivatedRouteSnapshot) {
    if(this.authService.isAuthenticated() && !this.securityService.currentUserInfo)
        return this.securityService.loadUserInfo().catch((e)=>{
          this.authService.toastr.error('Error in resolving current user');
          return Observable.of(e);
        });
    else
        return Observable.of<UserModel>(this.securityService.currentUserInfo);
  }
}


// WEBPACK FOOTER //
// ./src/app/auth/user.resolver.ts